import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const clearFilters = () => ({
  'type': ActionTypes.CLEAR_FILTERS,
});

export const changePartsListPage = (value) => ({
  'type': ActionTypes.CHANGE_PARTS_LIST_PAGE,
  'payload': value,
});

export const changePartsListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_PARTS_LIST_PAGE_SIZE,
  'payload': value,
});

export const changeCodeTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_CODE_TEXT_FILTER,
  'payload': value,
});

export const changeDescriptionTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_DESCRIPTION_TEXT_FILTER,
  'payload': value,
});

export const fetchPart = (code, position) => apiActionCreator({
  'endpoint': `/parts/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PART,
    {
      'type': ActionTypes.FETCHED_PART,
      'payload': position,
    },
    [
      ActionTypes.FETCHED_PART_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchBackOrdersDetail = (code, type = '') => {
  const queryString = type === '' ? '' : '?type=reservations';
  return apiActionCreator({
    'endpoint': `/parts/analysis/${code}/back-orders${queryString}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_BACK_ORDERS_DETAIL,
      ActionTypes.FETCHED_BACK_ORDERS_DETAIL,
      [
        ActionTypes.FETCHED_BACK_ORDERS_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchOnOrdersDetail = (code, consolidated = false, infoEmergent = false) => {
  const urlParams = getUrlParameters({
    infoEmergent,
    'consolidated': consolidated ? 'yes' : null,
  });

  return apiActionCreator({
    'endpoint': `/parts/analysis/${code}/on-orders${urlParams}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ON_ORDERS_DETAIL,
      ActionTypes.FETCHED_ON_ORDERS_DETAIL,
      [
        ActionTypes.FETCHED_ON_ORDERS_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchStockDetail = (code, dealersOnly = false) => {
  const queryString = dealersOnly ? '?dealersOnly=true' : '';
  return apiActionCreator({
    'endpoint': `/parts/analysis/${code}/stock${queryString}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_STOCK_DETAIL,
      ActionTypes.FETCHED_STOCK_DETAIL,
      [
        ActionTypes.FETCHED_STOCK_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
